export default __webpack_public_path__ + "58ea75213e3201fb2ac1998f59ffb49d.png";